import { CaseStatus, ContractStatus, DocumentStatus, FlexFormStatus, RefundStatus } from "../../types/graphql-global-types";
import Approved from "../icons/Status/Agreements/Approved";
import InApproval from "../icons/Status/Agreements/InApproval";
import Rejected from "../icons/Status/Agreements/Rejected";
import Running from "../icons/Status/Agreements/Running";
import Active from "../icons/Status/Cases/Active";
import InReview from "../icons/Status/Cases/InReview";
import Suspended from "../icons/Status/Cases/Suspended";
import Tentative from "../icons/Status/Cases/Tentative";
import Issued from "../icons/Status/Documents/Issued";
import WorkingDraft from "../icons/Status/Documents/WorkingDraft";
import Draft from "../icons/Status/Forms/Draft";
import Submitted from "../icons/Status/Forms/Submitted";
import { Resolved, Unresolved } from "../icons/Status/Quests/QuestStatusIcons";
import Matched from "../icons/Status/Records/Matched";
import Revoked from "../icons/Status/Records/Revoked";
import Unmatched from "../icons/Status/Records/Unmatched";
import Invoiced from "../icons/Status/Refunds/Invoiced";
import New from "../icons/Status/Refunds/New";
import Settled from "../icons/Status/Refunds/Settled";
import { FavoriteBorder, FavoriteIcon } from "../icons/FavoriteIcons";
import { AdjustedBorderIcon, AdjustedIcon, DeltaBorderIcon, DeltaIcon, MessagesBorder, MessagesIcon } from "../icons/MessagesIcons";

export enum QuestFilterStatus {
	UNRESOLVED = "Unresolved",
	RESOLVED = "Resolved",
}

export enum PublicAgreementStatus {
	ACTIVE = "Active",
	INACTIVE = "Inactive",
}

export enum NegotiationsHistoryStatus {
	YES = "yes",
	NO = "no",
}

export const statusBackgroundColors = {
	[CaseStatus.ACTIVE]: "#ecedfe",
	[CaseStatus.SUSPENDED]: "#e5eded",
	[CaseStatus.TENTATIVE]: "rgba(238, 227, 216, 0.6)",
	[ContractStatus.IN_APPROVAL]: "#ebfcfa",
	[ContractStatus.APPROVED]: "#e6f3eb",
	[ContractStatus.REJECTED]: "#fdefee",
	[ContractStatus.RUNNING]: "#ecedfe",
	[FlexFormStatus.REVOKED]: "#e5eded",
	[FlexFormStatus.MATCHED]: "#e6f3eb",
	[FlexFormStatus.UNMATCHED]: "#fdefee",
	[FlexFormStatus.DRAFT]: "#fef5df",
	[FlexFormStatus.SUBMITTED]: "#e6f3eb",
	[RefundStatus.INVOICED]: "#e6f3eb",
	[RefundStatus.NEW]: "#fef5df",
	[RefundStatus.PENDING]: "#ebfcfa",
	[RefundStatus.DECLINED]: "#fdefee",
	[DocumentStatus.IN_REVIEW]: "#ebfcfa",
	[DocumentStatus.ISSUED]: "#e6f3eb",
	[DocumentStatus.SETTLED]: "#ecedfe",
	[DocumentStatus.WORKING_DRAFT]: "#fef5df",
	[PublicAgreementStatus.ACTIVE]: "#ecedfe",
	[PublicAgreementStatus.INACTIVE]: "#e5eded",
	[QuestFilterStatus.RESOLVED]: "#e6f3eb",
	[QuestFilterStatus.UNRESOLVED]: "#fdefee",
};

export const statusColors = {
	[CaseStatus.ACTIVE]: "#614faa",
	[CaseStatus.SUSPENDED]: "#5e6e7d",
	[CaseStatus.TENTATIVE]: "#96714c",
	[ContractStatus.IN_APPROVAL]: "#007178",
	[ContractStatus.APPROVED]: "#038331",
	[ContractStatus.REJECTED]: "#ed544d",
	[ContractStatus.RUNNING]: "#614faa",
	[FlexFormStatus.REVOKED]: "#5e6e7d",
	[FlexFormStatus.MATCHED]: "#038331",
	[FlexFormStatus.UNMATCHED]: "#ed544d",
	[FlexFormStatus.DRAFT]: "#a87511",
	[FlexFormStatus.SUBMITTED]: "#038331",
	[RefundStatus.INVOICED]: "#038331",
	[RefundStatus.NEW]: "#a87511",
	[RefundStatus.PENDING]: "#007178",
	[RefundStatus.DECLINED]: "#ed544d",
	[DocumentStatus.IN_REVIEW]: "#007178",
	[DocumentStatus.ISSUED]: "#038331",
	[DocumentStatus.SETTLED]: "#614faa",
	[DocumentStatus.WORKING_DRAFT]: "#a87511",
	[PublicAgreementStatus.ACTIVE]: "#614faa",
	[PublicAgreementStatus.INACTIVE]: "#5e6e7d",
	[QuestFilterStatus.RESOLVED]: "#038331",
	[QuestFilterStatus.UNRESOLVED]: "#ed544d",
};

export const statusIcons = {
	[CaseStatus.ACTIVE]: Active,
	[CaseStatus.SUSPENDED]: Suspended,
	[CaseStatus.TENTATIVE]: Tentative,
	[ContractStatus.IN_APPROVAL]: InApproval,
	[ContractStatus.APPROVED]: Approved,
	[ContractStatus.REJECTED]: Rejected,
	[ContractStatus.RUNNING]: Running,
	[FlexFormStatus.REVOKED]: Revoked,
	[FlexFormStatus.MATCHED]: Matched,
	[FlexFormStatus.UNMATCHED]: Unmatched,
	[FlexFormStatus.DRAFT]: Draft,
	[FlexFormStatus.SUBMITTED]: Submitted,
	[RefundStatus.INVOICED]: Invoiced,
	[RefundStatus.NEW]: New,
	[RefundStatus.PENDING]: InReview,
	[RefundStatus.DECLINED]: Rejected,
	[DocumentStatus.IN_REVIEW]: InReview,
	[DocumentStatus.ISSUED]: Issued,
	[DocumentStatus.SETTLED]: Settled,
	[DocumentStatus.WORKING_DRAFT]: WorkingDraft,
	[PublicAgreementStatus.ACTIVE]: Running,
	[PublicAgreementStatus.INACTIVE]: Suspended,
	[QuestFilterStatus.UNRESOLVED]: Resolved,
	[QuestFilterStatus.RESOLVED]: Unresolved,
};

export const filterIcons = {
	["FavoriteIcon"]: FavoriteIcon,
	["FavoriteBorderIcon"]: FavoriteBorder,
	["MessagesIcon"]: MessagesIcon,
	["MessagesBorderIcon"]: MessagesBorder,
	["AdjustedIcon"]: AdjustedIcon,
	["AdjustedBorderIcon"]: AdjustedBorderIcon,
	["DeltaIcon"]: DeltaIcon,
	["DeltaBorderIcon"]: DeltaBorderIcon,
};
